jQuery(function ($) {
	const base = "growl-component-input-budget";
	const list = $(`.${base}`).data("list");
	const card = $(`.${base}`).data("card");

	$(`.${base}__input`).on("keyup change", function () {
		const budget = $(this).val();

		$(`.${list} > .${card}`).each(function () {
			if (
				(budget && $(this).data("price") > budget) ||
				(budget && !Number.isInteger($(this).data("price")))
			) {
				$(this).addClass(`${card}--out-of-budget`);
			} else {
				$(this).removeClass(`${card}--out-of-budget`);
			}
		});

		sessionStorage.setItem("budget", budget);
	});

	if (sessionStorage.getItem("budget")) {
		$(`.${base}__input`).val(sessionStorage.getItem("budget"));
		$(`.${base}__input`).trigger("change");
	}
});
